import { Button, ButtonSize, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import Trans from "@/components/Trans/Trans";

interface IUserProfileFooterProps {
  logoutAndGoToHome: () => void;
}

export const UserProfileFooter = ({ logoutAndGoToHome }: IUserProfileFooterProps) => {
  return (
    <div className="flex flex-row justify-between py-md ">
      <div className="flex flex-col gap-[2px]">
        <Text variant={TextVariants.LABEL_LARGE_REGULAR}>
          <Trans i18nKey="user:profile.footer.signout.title" />
        </Text>
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className={"text-gray-11"}>
          <Trans i18nKey="user:profile.footer.signout.description" />
        </Text>
      </div>
      <Button size={ButtonSize.LARGE} variant={ButtonVariant.SECONDARY} onClick={logoutAndGoToHome}>
        <Trans i18nKey="common:signOut" />
      </Button>
    </div>
  );
};
